import { twMerge } from 'tailwind-merge'
import { Route } from 'lucide-react'

import { LockClosedIcon } from '@heroicons/react/24/outline'
import { BoltIcon } from '@heroicons/react/24/solid'
import { durationInWords } from '@helpers/format'

import { stripMarkdown } from '@helpers/format'
import { getCourseVisualStyle } from '@helpers/courseUtils'
import Image from '@components/Image'

const CourseCard = ({ className, name, description, imageUrl, courseId, assignment }) => {
  const formattedDescription = stripMarkdown(description)
  const { emoji, gradientFrom, gradientTo } = getCourseVisualStyle(courseId)

  return (
    <div className={twMerge('grow h-full', className)}>
      <div className="font-dm-sans border rounded-lg bg-background overflow-hidden h-full">
        <Choose>
          <When condition={imageUrl}>
            <Image
              className="w-full h-32 object-cover"
              src={imageUrl}
              placeholder={<div className="w-full h-32 bg-gray-200 animate-pulse"></div>}
            />
          </When>

          <Otherwise>
            <div
              className="w-full h-32 flex items-center justify-center text-5xl"
              style={{ background: `linear-gradient(135deg, ${gradientFrom}, ${gradientTo})` }}
            >
              {emoji}
            </div>
          </Otherwise>
        </Choose>

        <div className="p-4">
          <h2 className="text-sm font-semibold line-clamp-1">{name}</h2>

          <If condition={formattedDescription}>
            <p className="text-sm text-gray-500 line-clamp-2 break-all">
              {formattedDescription}
            </p>
          </If>
          <div className='flex items-center mt-1 sm:ml-0 ml-3'>
            <Choose>
              <When condition={assignment.closed}>
                <LockClosedIcon className='size-4 mr-2 shrink-0 text-red-500' />
                <p className='pt-1 text-sm leading-none text-gray-500'>Closed, assigned by {assignment.profile.fullName}</p>
              </When>

              <Otherwise>
                <BoltIcon className='size-4 mr-2 shrink-0 text-green-500' />
                <p className='pt-1 text-sm leading-none text-gray-500'>Assigned {durationInWords(assignment.createdAt)}, by {assignment.profile.fullName}</p>
              </Otherwise>
            </Choose>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseCard
